export enum LoaderType {
  SMALL = 'loadingSmall',
  LARGE = 'loadingLarge',
  EXTRA_SMALL = 'loadingExtraSmall',
  HERO_BANNER = 'loadingHeroBanner',
}
